import { TextField } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { useDebounce } from "usehooks-ts"
import { useObjectActions } from "../../../../hooks/useObjectActions"
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux"
import { setIsEditingTextMode } from "../../../../store/slices/editor.slice"

interface Props {
    objectId: string
    initialText: string
}

const EditableText = ({ objectId, initialText }: Props) => {
    const dispatch = useAppDispatch()
    const [text, setText] = useState(initialText)
    const inputRef = useRef<HTMLInputElement | null>(null)
    const debouncedValue = useDebounce<string>(text)
    const { updateObject } = useObjectActions()
    const isEditingTextMode = useAppSelector((state) => state.editor.value.isEditingTextMode)
    const selectedObjectIds = useAppSelector((state) => state.activeObject.selected)

    useEffect(() => {
        if (selectedObjectIds.length === 0) {
            dispatch(setIsEditingTextMode(false))
        }
    }, [dispatch, selectedObjectIds])

    useEffect(() => {
        setText(initialText || " ")
    }, [initialText])

    useEffect(() => {
        if (initialText !== debouncedValue) {
            updateObject(objectId, "text", debouncedValue)
        }
    }, [debouncedValue, initialText, objectId, updateObject])

    useEffect(() => {
        if (isEditingTextMode && inputRef.current) {
            inputRef.current.focus()
            inputRef.current.select()
        }
    }, [isEditingTextMode])

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setText(e.target.value || " ")
    }

    const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            if (initialText !== text) {
                updateObject(objectId, "text", text)
            }
            dispatch(setIsEditingTextMode(false))
        }
    }

    return isEditingTextMode ? (
        <TextField
            id="row-editable-text"
            name="text"
            className="headerInput"
            value={text}
            inputRef={inputRef}
            autoFocus
            fullWidth
            type="text"
            onChange={handleOnChange}
            onKeyDown={handleOnKeyDown}
            inputProps={{
                style: {
                    height: 44,
                    padding: 0.5,
                    fontSize: "28px",
                },
            }}
        />
    ) : null
}

export default EditableText
